<template>
    <v-overlay v-model="shows" absolute v-if="mode == 'overlay'">
        <v-card class="d-flex flex-column align-center" flat rounded="xl" color="primary" @click="open">
            <v-icon size="240">mdi-file-upload</v-icon>
            <v-card-title>계약서 양식 문서를 업로드해주세요</v-card-title>
            <v-file-input v-model="file" v-show="false" ref="v-file-input" @change="emit" />
        </v-card>
    </v-overlay>
    <v-btn small text icon v-else-if="mode == 'button'" @click="open">
        <v-icon>mdi-file-upload-outline</v-icon>
        <v-file-input v-model="file" v-show="false" ref="v-file-input" @change="emit" />
    </v-btn>
</template>

<script>
export default {
    props: {
        value: { type: [File, Object], default: null },
        mode: { type: String, default: "overlay" },
    },
    setup: () => ({}),
    data: () => ({
        file: null,
        shows: false,
    }),
    computed: {},
    methods: {
        sync() {
            this.file = this.value;
            this.shows = !this.file;
        },
        emit() {
            this.$emit("input", this.file);
        },
        open() {
            this.$refs["v-file-input"]?.$refs?.["input"]?.click?.();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped></style>
